import React, { useEffect, useState } from "react";
import "./carrinhoCompras.css";
import DeleteIcon from "@mui/icons-material/Delete";
import { ReturnName, ReturnNamePage } from "../../../utils/coins";
import CountryFlags from "../../../utils/countryFlags";
import DetalhesPedido from "../detalhes-pedido/detalhesPedido";
import InformacoesPedido from "../../components/informacoesPedido";
import EmbalagemProtetora from "../detalhes-pedido/embalagemProtetora";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../../../services/dexie/stores";
import { PageLoading } from "../../../components/Loading/Loading";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddIcon from "@mui/icons-material/Add";
import BrindesComponent, { findBrindeByItem } from "./brindes/brindes";
import styled from "styled-components";
import { AlertNotify } from "../../../components/alerts/AlertNotify";

import embalagem from "../../../assets/images/modules/embalagem-protetora.jpg";
import { getClienteByCodigo } from "../../../services/modules/cliente/clienteService";
import { getClienteCodigo } from "../../../utils/localStorage";
import { QuantidadeField } from "./components";
import { ModalCupomDesconto } from "./modalCupomDesconto";

const styleIcons = {
  width: ".8rem",
  justifyContent: "center",
  marginRight: "5px",
};

const styleNext = {
  color: "#ffffff",
};

export default function CarrinhoCompras() {
  const [totalItems, setTotalItems] = useState(0);
  const [data, setData] = useState([]);
  const [valid, setValid] = useState(true);
  const [load, setLoad] = useState(false);
  const [messageError, setMessageError] = useState("");
  const [messageStyle, setMessageStyle] = useState("");
  const [totalCompra, setTotalCompra] = useState(0);
  const [cupom, setCupom] = useState("");
  const [brindeSelecionado, setBrindeSelecionado] = useState(false);
  const [isEmbalagemProtetora, setIsEmbalagemProtetora] = useState(0);
  const [isMediaDesktop, setIsMediaDesktop] = useState(false);
  const [dataCupom, setDataCupom] = useState([]);
  const observable = useLiveQuery(() => db.carrinho.toArray());
  const navigate = useNavigate();

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1024px)");
    setIsMediaDesktop(mediaQuery.matches);
  }, []);

  useEffect(() => {
    async function set() {
      setMessageError("");
      const resp = await db.getCarrinho();
      if (resp.length === 0) return;
      let value = 0;
      let message = "";
      setValid(true);
      const coins = resp.filter(
        (item) => item.tipo !== "brinde" && item.id !== "endereco"
      );

      const brinde = resp.find((item) => item.tipo === "brinde");
      if (brinde) {
        const resp = findBrindeByItem(brinde.nome);
        if (resp) setBrindeSelecionado(resp);
      }
      let embalagemProtetora = 0;
      coins.map((item) => {
        if(item.quantidade < 1) {
          setValid(false);
        }
        if (item.embalagemProtetora === true) {
          embalagemProtetora++;
        }
        //Verifica o limite aplicado para cada moeda
        const valor = item.valor * item.quantidade;
        if (item.liberadoBR === 0) {
          message += `\n\nVocê não tem limite disponível para a moeda ${ReturnName(
            item.codIso
          )}.`;
          setValid(false);
        } else if (valor > item.liberadoBR) {
          message += `\n\nO seu limite máximo para a moeda ${ReturnName(
            item.codIso
          )} é de ${parseFloat(item.liberadoBR).toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          })}. Para finalizar a sua compra, escolha uma quantidade dentro desse valor.`;
          setValid(false);
          AlertNotify({type: "warning", message: message});
        }
        return (value += item.valor * item.quantidade);
      });
      setIsEmbalagemProtetora(embalagemProtetora);
      setMessageError(message);

      setTotalItems(coins.length);
      setData(coins);
      setTotalCompra(value);
    }
    setLoad(true);
    set().finally(() => setLoad(false));
  }, [observable]);

  useEffect(() => {
    if (data.length === 0) {
      setValid(false);
      setLoad(false);
    }
  }, [data]);

  useEffect(() => {
    const codigo = getClienteCodigo();
    setLoad(true);
    getClienteByCodigo(codigo)
      .then((resp) => {
        const docs = resp.documentos || [];

        const has1072 = docs.some((doc) => doc.tipoDocumento === "1072");
        const has1009 = docs.some((doc) => doc.tipoDocumento === "1009");
        const has1008 = docs.some((doc) => doc.tipoDocumento === "1008");

        const allRequiredDocsPresent = has1072 && has1009 && has1008;

        if (!allRequiredDocsPresent) {
          AlertNotify({
            message:
              "Para continuar comprando, é necessário que você envie os documentos obrigatórios.",
            type: "warning",
          });

          navigate("/om/painel/perfil/dados-pessoais");
        }
      })
      .catch((e) => e)
      .finally(() => setLoad(false));
  }, []);
  const aplicarDesconto = async () => {
    try {
      const cupomValido = await db.validarCupom(cupom);

      if (!cupomValido) {
        setMessageError("Cupom inválido ou expirado.");
        setMessageStyle("error-message");
        setCupom("");
        return;
      }
      const moedasPermitidas = data.filter((item) =>
        cupomValido.moedasPermitidas.includes(
          item.codIso === "EUSCOM" ? "USD" : item.codIso
        )
      );

      if(moedasPermitidas.length === 0) {
        AlertNotify({type: "warning", message: "O cupom não é aplicável para a moeda selecionada."});
        setMessageError(`O cupom não é aplicável para a moeda selecionada.`);
        setMessageStyle("error-message");
        return;
      }
      moedasPermitidas.forEach((moedaPermitida) => {

        const totalMoeda = moedaPermitida.valor * moedaPermitida.quantidade;

        if (totalMoeda < cupomValido.valor) {
          setDataCupom(moedasPermitidas);
          return;
        }

        let valorDesconto = cupomValido.desconto;

        const novoTotalCompra =
          totalMoeda - Math.min(valorDesconto, totalMoeda);

        if (novoTotalCompra < 0) {
          setMessageError(
            "O desconto não pode ser maior que o valor da compra."
          );
          setMessageStyle("error-message");
          return;
        }

        db.setCupom(moedaPermitida, cupomValido);
        AlertNotify({ message: "Cupom aplicado com sucesso!" });
        setMessageError("Cupom aplicado com sucesso!");
        setMessageStyle("success-message");
      });
    } catch (error) {
      AlertNotify({
        message: "Erro ao aplicar o cupom. Por favor, tente novamente.",
        type: "error",
      });
      setMessageError("Erro ao aplicar o cupom. Por favor, tente novamente.");
      setMessageStyle("error-message");
    }
  };

  const onToggleBrinde = (value) => {
    setBrindeSelecionado(value);
    const brinde = {
      id: "brinde",
      nome: value.item,
      quantidade: 1,
      valor: 0,
      tipo: "brinde",
      ...value,
    };
    db.setItem(brinde, "brinde");
  };

  const onRemoveBrinde = () => {
    setBrindeSelecionado(null);
    db.deleteItemCarrinho("brinde");
  };


  return (
    <>
      <div className="principal">
        <div className="carrinho">
          <div className="itens">
            <h3>Carrinho de compras</h3>
            <div>
              <p>{totalItems}</p>
              <p>{totalItems === 1 ? "item" : "items"}</p>
            </div>
          </div>
          <ModalCupomDesconto data={dataCupom} cupom={cupom} />
          <div>
            {load && <PageLoading />}
            <hr className="dividerCarrinho" />
            {data?.map((item) => (
              <React.Fragment key={item.codIso}>
                <div className="menuPrincipal">
                  <div className="menuCompras">
                    <div className="div1">
                      <div
                        className="container-img"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "72px",
                        }}
                      >
                        <CountryFlags cod={item.codIso} />
                        <button
                          className="remover"
                          onClick={() => {
                            db.deleteItemCarrinho(item.id);
                          }}
                        >
                          <DeleteIcon style={styleIcons} />
                          Remover
                        </button>

                        <EmbalagemProtetora id={item.id} />
                      </div>
                      <div>
                        <p style={{ color: "#004133", fontWeight: "600" }}>
                          <span>
                            {ReturnName(item?.codIso)?.split(" ", 1) ||
                              item?.nome}
                          </span>{" "}
                          <span>
                            ({item.codIso === "EUSCOM" ? "USD" : item.codIso})
                          </span>
                        </p>
                        <p>{ReturnNamePage(item.tipo)}</p>
                      </div>
                    </div>

                    <div className="div2">
                      <div className="controle-quantidade">
                        <p>Quantidade:</p>
                        <QuantidadeField item={item} setData={setData} key={item.id}  />

                      </div>
                      <p>Total:</p>
                      <p className="valor">
                        {parseFloat(
                          item.quantidade * item.valor
                        ).toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </p>
                      <div>
                        <button>
                          <DetalhesPedido item={item} />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="dividerCarrinho" />
              </React.Fragment>
            ))}
            {isEmbalagemProtetora > 0 && (
              <>
                <div className={"brinde-selecionado"}>
                  <div>
                    <div className="brinde-info">
                      <img
                        src={embalagem}
                        alt="embalagem protetora"
                        className="brinde-imagem"
                      />
                      <h4 className="brinde-titulo">Embalagem Protetora</h4>
                    </div>
                  </div>
                  <div className="brinde-detalhes">
                    <div className="brinde-quantidade-valor">
                      <p className="quantidade">
                        Quantidade: {isEmbalagemProtetora}
                      </p>
                      <p className="valor-brinde">Total:&nbsp; R$ 0,00</p>
                    </div>
                  </div>
                </div>
                <hr className="dividerCarrinho" />
              </>
            )}
            {brindeSelecionado && (
              <>
                <div className={"brinde-selecionado"}>
                  <div>
                    <div className="brinde-info">
                      <img
                        src={brindeSelecionado.image}
                        alt={brindeSelecionado.item}
                        className="brinde-imagem"
                      />
                      <h4 className="brinde-titulo">
                        {brindeSelecionado.item}
                      </h4>
                    </div>
                    <button className="remover" onClick={onRemoveBrinde}>
                      <DeleteIcon style={styleIcons} />
                      Remover
                    </button>
                  </div>
                  <div className="brinde-detalhes">
                    <div className="brinde-quantidade-valor">
                      <p className="quantidade">Quantidade: 1</p>
                      <p className="valor-brinde">Total:&nbsp; R$ 0,00</p>
                    </div>
                  </div>
                </div>
                <hr className="dividerCarrinho" />
              </>
            )}
            <div className="detalhes">
              <button
                className="remover"
                onClick={() => {
                  navigate("/om/servicos-cambio/moedas-estrangeiras");
                  // handleMoedaSelecionada();
                }}
              >
                <AddIcon style={styleIcons} />
                Adicionar mais produtos
              </button>
              <p className="remover">Tem cupom de desconto?</p>
              <div className="codigoPromocional">
                <input
                  type="text"
                  placeholder="Código"
                  value={cupom}
                  onChange={(e) => setCupom(e.target.value)}
                ></input>
                <button className="next" onClick={aplicarDesconto}>
                  <NavigateNextIcon style={styleNext} />
                </button>
              </div>
              {messageError && (
                <div
                  className={`message ${messageStyle}`}
                  style={{
                    color: messageStyle === "error-message" ? "red" : "green",
                    fontWeight: "bold",
                    marginTop: "10px",
                    fontSize: "0.9rem",
                  }}
                >
                  {messageError}
                </div>
              )}
            </div>
          </div>
        </div>
        {!isMediaDesktop && !brindeSelecionado && (
          <BrindesComponent
            onToggleBrinde={onToggleBrinde}
            valorCompra={totalCompra}
            carrinho={data}
          />
        )}

        <div className="informacoesPedido">
          <InformacoesPedido
            linkButton="formas-entrega"
            textButton="Formas de entrega"
            show={valid}
          />
        </div>
      </div>
      {isMediaDesktop && !brindeSelecionado && (
        <ContainerDesktop>
          <BrindesComponent
            onToggleBrinde={onToggleBrinde}
            valorCompra={totalCompra}
            carrinho={data}
          />
        </ContainerDesktop>
      )}
    </>
  );
}

const ContainerDesktop = styled.div`
  .brindes {
    width: 100%;
    margin: 0;
    background-color: #f7f7f7;

    h3 {
      margin-top: 0;
    }

    @media (min-width: 1024px) {
      padding-left: 65px;
    }
    @media (min-width: 1400px) {
      padding: 0;
    }
  }
`;
